'use client';
import React, { FC } from 'react';
import Link from 'next/link';
import AmplienceDynamicComponent from '../dynamic-component';
export interface AmplienceContainerProps {
  items: any[];
  url?: string;
  border?: boolean;
  ariaLabel?: string;
}
const AmplienceContainer: FC<AmplienceContainerProps> = ({ items, url, border, ariaLabel }) => {
  const borderStyles = border
    ? 'rounded-[10px] border border-gray-400 p-[30px] max-[500px]:max-w-full max-[500px]:p-[10px] max-[500px]:[&_h3]:max-w-full max-[500px]:[&_h3]:text-[12px] max-[500px]:[&_h3]:leading-[1.4]'
    : '';

  return url ? (
    <Link href={url} aria-label={ariaLabel}>
      <div className={`flex flex-col ${borderStyles}`} data-testid={'container-component'}>
        {items.map((item, index) => (
          <div key={'container-component-' + index} data-testid={'container-component-item'}>
            <AmplienceDynamicComponent data={item} />
          </div>
        ))}
      </div>
    </Link>
  ) : (
    <div className={`flex flex-col ${borderStyles}`} data-testid={'container-component'}>
      {items.map((item, index) => (
        <div key={'container-component-' + index} data-testid={'container-component-item'}>
          <AmplienceDynamicComponent data={item} />
        </div>
      ))}
    </div>
  );
};

export default AmplienceContainer;
